import {OXFORD} from "@/configs/config_api_backend"
import stringInject from 'stringinject'
import http from "@/plugins/http"

const lookupOxfordService = async (word) => {
    try {
        let url = stringInject(OXFORD.LOOKUP, {'word': word})
        // console.log(url)
        let response = await http.get(url)
        return response.data
    } catch (e) {
        console.warn(e)
        return []
    }
}

export {lookupOxfordService}
